import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { AssessmentProvider } from "@/context/AssessmentContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import BookYourStay from "@/pages/BookYourStay";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Packages from "@/pages/Packages";
import Process from "@/pages/Process";
import ListProperty from "@/pages/ListProperty";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/admin/Admin";
import AuthCallback from "@/pages/admin/AuthCallback";
import PortfolioProject from "@/pages/PortfolioProject";
function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST (synchronously during render).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/admin" element={<Admin />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
  <Route path="/book-your-stay" element={<BookYourStay />} />
  <Route path="/portfolio/:slug" element={<PortfolioProject />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/process" element={<Process />} />
        <Route path="/list-your-property" element={<ListProperty />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AssessmentProvider>
            <AppRouter />
          </AssessmentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
